<template>
  <vk-dialog
    :visible.sync="visible"
    :showTitle="false"
    width="300px"
    @close="closeDialog"
    class="ping-pay-result-dialog"
  >
    <div class="success-module">
      <div class="clearfix">
        <i></i>
        <span class="info">如果已成功支付，请点击</span>
      </div>
      <span
        class="result-btn"
        @click="paySuccess"
      >已完成支付</span>
    </div>
    <div class="error-module">
      <div class="clearfix">
        <i></i>
        <span class="info">如果付款遇到问题，您可以</span>
      </div>
      <span
        class="result-btn"
        @click="repeatPay"
      >重新支付</span>
      <span class="or-method">或<span
          class="change-pay-method"
          @click="changePayChannel"
        >选择其他支付方式</span></span>
    </div>
  </vk-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    visible: function (val) {
      console.log(val)
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    changePayChannel() {
      this.closeDialog()
    },
    paySuccess() {
      this.closeDialog()
      this.$router.push({
        path: '/order/list'
      })
    },
    repeatPay() {
      this.$emit('repeatPay')
      this.closeDialog()
    }
  }
}
</script>

<style lang="less">
.dialog-component {
  &.ping-pay-result-dialog {
    color: #666;
    font-size: 12px;
    .success-module,
    .error-module {
      text-align: center;
      i {
        float: left;
        width: 43px;
        height: 44px;
        margin: 0 15px;
      }
      span {
        &.info {
          float: left;
          height: 44px;
          line-height: 44px;
        }
      }
    }
    .success-module {
      border-bottom: 1px solid #e0e0e0;
      padding: 8px 20px 25px;
      i {
        background: url("../../../../assets/images/order/bg.png") no-repeat 0 -43px;
      }
    }
    .error-module {
      padding: 28px 20px 25px;
      i {
        background: url("../../../../assets/images/order/bg.png") no-repeat -43px -43px;
      }
      .or-method {
        display: inline-block;
        margin-top: 18px;
        .change-pay-method {
          color: #f60;
          cursor: pointer;
        }
      }
    }
    .result-btn {
      display: block;
      width: 94px;
      height: 30px;
      line-height: 28px;
      border: 1px solid #8f8f8f;
      background-color: #e3e3e3;
      margin: 0 auto;
      border-radius: 3px;
      cursor: pointer;
      margin-top: 15px;
    }
  }
}
</style>
